import React from 'react';

import { styled } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';

import ClearIconComponent from './ui/ClearIconComponent';
import { concatenateSelectedValues } from '../../../IndicatorsBanners/helpers';

const StySelect = styled(Select)(({ theme }) => ({
    borderRadius: theme.spacing(3),
    '&&& .MuiSelect-select': {
        display: 'block',
        paddingRight: '0px',
    },
}));

type MetricFilterSelectProps<T extends string> = {
    open: boolean;
    closeModal: () => void;
    openModal: () => void;
    label: string;
    selectedFilterOptions: T[];
    setSelectedFilterOptions: (arg1: T[]) => void;
};

const MetricFilterSelect = <T extends string>({
    open,
    closeModal,
    openModal,
    label,
    selectedFilterOptions,
    setSelectedFilterOptions,
}: MetricFilterSelectProps<T>): JSX.Element => {
    const clearSelectedFilterOptions = () => setSelectedFilterOptions([]);
    return (
        <Tooltip title={concatenateSelectedValues(selectedFilterOptions)}>
            <FormControl sx={{ width: '100%' }} size="small">
                <InputLabel>{label}</InputLabel>
                <StySelect
                    className="pendo-indicators-library-metric-filter"
                    open={open}
                    onClose={closeModal}
                    onOpen={openModal}
                    label={label}
                    value={selectedFilterOptions}
                    renderValue={concatenateSelectedValues}
                    IconComponent={ClearIconComponent(
                        clearSelectedFilterOptions,
                        selectedFilterOptions.length > 0,
                    )}
                />
            </FormControl>
        </Tooltip>
    );
};

export default MetricFilterSelect;
